module.exports = __webpack_public_path__ + "img/logo.3fbd8a98.png";